import type { Entity } from "models/entity";
import { twMerge } from "tailwind-merge";

import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons/faCaretUp";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import { usePriceQuote } from "hooks/usePriceQuote";
import { numberSignificance } from "utils/common";

const PriceQuote = ({ entity }: { entity: Entity }) => {
  const { price, percentage, currency } = usePriceQuote(entity?.security);

  if (price && percentage) {
    return (
      <div className="text-[12px] transition-width duration-400">
        <div className="text-center">
          {numberSignificance({ num: price, maxDecimalPlaces: 2 })}
        </div>
        <div
          className={twMerge(
            "flex items-center justify-center",
            percentage < 0 ? "text-bearish-red" : "text-bullish-green"
          )}
        >
          <FontAwesomeIcon
            className="text-[14px] mr-[3px]"
            icon={percentage < 0 ? faCaretDown : faCaretUp}
          />
          <span>
            {Math.abs(
              numberSignificance({
                num: percentage,
                maxDecimalPlaces: 2,
              })
            )}
            %
          </span>
        </div>
      </div>
    );
  }

  return <></>;
};

export default PriceQuote;
